export function isNumber(data) {
    return typeof data === 'number' && !isNaN(data);
}
export function isString(data) {
    return typeof data === 'string';
}
export function isDefined(data) {
    return typeof data !== 'undefined' && data !== null;
}
export function isBoolean(data) {
    return typeof data === 'boolean';
}
export function isFunction(data) {
    return typeof data === 'function';
}
export function isUndefined(data) {
    return typeof data === 'undefined' || data === null;
}
/**
 * Guard that filters undefined and null values. 0 and false value will not be filtered.
 */
export function notEmpty(v) {
    // tslint:disable-next-line:no-if-statement
    if (isArray(v)) {
        return v.length !== 0;
    }
    // tslint:disable-next-line:no-if-statement
    if (isObject(v)) {
        return Object.keys(v).length !== 0;
    }
    if (isNumber(v) && !isNaN(v)) {
        return true;
    }
    if (isBoolean(v)) {
        return true;
    }
    if (isString(v) && v !== '') {
        return true;
    }
    return !!v;
}
export function isArray(data) {
    return Array.isArray(data);
}
export function isObject(data) {
    return !!data && !Array.isArray(data) && typeof data === 'object';
}
export function or(...args) {
    return (data) => {
        return args
            .map((c) => {
            return c(data);
        })
            .some((c) => c);
    };
}
export function hasKeys(keys, data
// @ts-ignore
) {
    if (arguments.length === 1) {
        // @ts-ignore
        return (d) => {
            return hasKeys(keys, d);
        };
    }
    if (isObject(data)) {
        const k = Object.keys(data);
        return keys.every((q) => k.includes(q));
    }
    return false;
}
export function isTypeOf(type, data) {
    if (!data) {
        return (d) => {
            return isTypeOf(type, d);
        };
    }
    return isTypeOf(type, data);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isKeyofGuard(value, object) {
    return value in object;
}
export function not(fn) {
    return (data) => {
        return !fn(data);
    };
}
